import Rune from "../images/Rune";
import styles from "./KeystonePlus.module.css";

const KeystonePlus = ({ keystone, secondary }) => {
  return (
    <div className={styles.runes}>
      <Rune rune={keystone} size={34} />
      <img
        className={styles.secondary}
        src={`https://cdn5.xdx.gg/runestyle16/${secondary}.webp`}
        srcSet={`https://cdn5.xdx.gg/runestyle16/${secondary}.webp 16w,
                 https://cdn5.xdx.gg/runestyle32/${secondary}.webp 32w,`}
        alt={secondary}
      />
    </div>
  );
};

export default KeystonePlus;
